import ProductionAppHost from "./components/ProductionAppHost.svelte";
import "./styles.css";
import { mount } from "svelte";
import { registerPushServiceWorker } from "./push";

const target = document.getElementById("app");

if (!target) {
  throw new Error("Missing #app target");
}

mount(ProductionAppHost, { target });

void registerPushServiceWorker().catch(() => {
  // Settings exposes registration failures when the user chooses notifications.
});
